__turbopack_context__.v({
  "container": "styles-module-scss-module__klgjka__container",
  "dragging": "styles-module-scss-module__klgjka__dragging",
  "dropInner": "styles-module-scss-module__klgjka__dropInner",
  "hasPreview": "styles-module-scss-module__klgjka__hasPreview",
  "imageDropZone": "styles-module-scss-module__klgjka__imageDropZone",
  "label": "styles-module-scss-module__klgjka__label",
  "linkInputField": "styles-module-scss-module__klgjka__linkInputField",
  "linkSearchIcon": "styles-module-scss-module__klgjka__linkSearchIcon",
  "textRefineInput": "styles-module-scss-module__klgjka__textRefineInput",
  "title": "styles-module-scss-module__klgjka__title",
  "uploadLink": "styles-module-scss-module__klgjka__uploadLink",
});
